/**
 * Row-to-response lookup shared by the future-dates modal layouts (`FutureDatesDesktop.tsx`,
 * `FutureDatesMobile.tsx`).
 */
import { UpdatedShoppingCartDataType } from "./FutureDatesModal";
import { DraftQuoteLineItem } from "@ryerson/frontend.common";
import { IDeliveryTimesResponse } from "@ryerson/common.models";
import { isShoppingCartDataType } from "@components/Helper/TypeHelpers";

/**
 * Finds the delivery-times entry for one modal row: same SKU (`materialMaster` for a cart line,
 * `skuNumber` for a draft-quote line) and same `itemNumber`. `undefined` when the response has
 * no entry for the row.
 */
export const getLeadTimeAndDeliveryDates = (
	rowData: UpdatedShoppingCartDataType | DraftQuoteLineItem,
	productsDeliveryTimes: IDeliveryTimesResponse[]
) =>
	productsDeliveryTimes.find(
		(product) =>
			product.materialSku ===
				(isShoppingCartDataType(rowData) ? rowData.materialMaster : rowData.skuNumber) &&
			product.itemNumber === rowData.itemNumber
	);
